import {
  Transforms,
  Editor,
  Element as SlateElement
} from 'slate';

import * as basicEditorValueSerializer from 'basic-editor-value-serializer';

import types from '../../elements/types';

import HelptapEditor from '../';

export function getDefaultOptions() {

  return basicEditorValueSerializer.utilities.node.paragraph.getDefaultOptions();

}

export function buildNode(options = {}) {

  const node = {
    ...getDefaultOptions(),
    type: types.LAST_UPDATED,
    children: [{ text: '' }],
    width: '300px',
    marginRight: 'auto'

  };

  node.properties = {
    ...node.properties,
    ...options
  };

  return node;

}

export function insert(editor, options, editorOptions, targetNodePath, nextNodePath) {

  Transforms.insertNodes(editor, buildNode(options), { at: targetNodePath });

}

export function toggle(editor, options, editorOptions, targetNodePath, nextNodePath) {

  const nodeOptions = buildNode(options);

  HelptapEditor.setNodeOptions(editor, nodeOptions);

}

export function duplicate(editor, node, nodePath) {

  const clonedNode = HelptapEditor.cloneNode(node);

  HelptapEditor.insertNode(editor, clonedNode, nodePath);

}

export function update(editor) {

  const iterator = Editor.nodes(editor, {
    at: [], // Search the entire document
    match: n =>
      SlateElement.isElement(n) && n.type === types.LAST_UPDATED
  });

  const entries = Array.from(iterator);

  if (entries.length === 0) {
    return;
  }

  Editor.withoutNormalizing(editor, () => {

    for (const [node, path] of entries) {

      const date = new Date();

      date.setMilliseconds(0);
      date.setSeconds(0);

      const dateTime = date.getTime();

      if (node.properties.lastUpdatedAt === dateTime) {
        continue;
      }

      Transforms.setNodes(
        editor, {
          properties: {
            ...node.properties,
            lastUpdatedAt: dateTime,
            lastUpdatedAtString: date.toISOString()
          }
        }, { at: path }
      );

    }

  });

}